import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';

export const bootstrap = new BootstrapBrowserBuilder('hotpads-web', Number(__BUILD_NUMBER__))
  .withLoggerOptions({
    logPath: '/log',
    level: 'info',
  })
  .build();
